class CustomWholesaleGate {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('#CustomWholesaleGateForm');
    this.content = root.querySelector('[data-custom-wholesale-gate-state]');
    this.messageField = root.querySelector('[data-custom-wholesale-gate-body]');
    this.submitButton = root.querySelector('[data-custom-wholesale-gate-submit]');
    this.dismissButtons = root.querySelectorAll('[data-custom-wholesale-gate-dismiss]');
    this.openButtons = document.querySelectorAll(
      '[data-custom-wholesale-gate-open], a[href="#wholesale-application"]'
    );
    this.storageKey = root.dataset.storageKey || 'custom-wholesale-gate-submitted';
    this.pendingKey = `${this.storageKey}-pending`;
    this.dismissedKey = `${this.storageKey}-dismissed`;
    this.delayMs = Number(root.dataset.delayMs || 5000);
    this.showTimer = null;
    this.fields = {
      name: root.querySelector('[data-custom-wholesale-gate-name]'),
      email: root.querySelector('[data-custom-wholesale-gate-email]'),
      phone: root.querySelector('[data-custom-wholesale-gate-phone]'),
      business: root.querySelector('[data-custom-wholesale-gate-business]'),
      businessID: root.querySelector('[data-custom-wholesale-gate-business-id]'),
      address: root.querySelector('[data-custom-wholesale-gate-address]'),
    };
  }

  init() {
    this.bindDismissButtons();
    if (!this.form || !this.content) return;
    this.bindOpenButtons();

    if (window.Shopify && Shopify.designMode) {
      this.hide();
      return;
    }

    const isSubmittedOnServer = this.content.dataset.customWholesaleGateState === 'true';
    const hasErrors = this.content.dataset.customWholesaleGateHasErrors === 'true';

    if (isSubmittedOnServer) {
      this.persistSubmission();
      this.clearPendingValues();
      this.show();
      return;
    }

    if (this.hasSubmitted()) {
      this.hide();
      return;
    }

    if (this.isDismissed()) {
      this.hide();
      return;
    }

    this.restorePendingValues();
    this.bindForm();

    if (hasErrors) {
      this.show();
      return;
    }

    this.scheduleShow();
  }

  bindOpenButtons() {
    this.openButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.show();
      });
    });
  }

  bindForm() {
    Object.values(this.fields).forEach((field) => {
      if (!field) return;
      field.addEventListener('input', () => this.savePendingValues());
    });

    this.form.addEventListener('submit', () => {
      this.updateMessageField();
      this.savePendingValues();

      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.textContent = 'Submitting...';
      }
    });
  }

  bindDismissButtons() {
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('[data-custom-wholesale-gate-dismiss]');
        const currentRoot = button?.closest('[data-custom-wholesale-gate]');
        if (!currentRoot) return;

        event.preventDefault();
        this.root = currentRoot;
        this.persistDismissal();
        this.hide();
      },
      true
    );
  }

  updateMessageField() {
    if (!this.messageField) return;

    const payload = [
      'Wholesale account request',
      `Theme: 2026 Wholesale Theme`,
      `Requested recipient: farm@topshelfaquatics.com`,
      `Name: ${this.fields.name?.value || ''}`,
      `Email: ${this.fields.email?.value || ''}`,
      `Phone: ${this.fields.phone?.value || ''}`,
      `Business: ${this.fields.business?.value || ''}`,
      `Business ID: ${this.fields.businessID?.value || ''}`,
      `Street address: ${this.fields.address?.value || ''}`,
    ];

    this.messageField.value = payload.join('\n');
  }

  focusFirstField() {
    const firstField = Object.values(this.fields).find((field) => field);
    if (!firstField) return;

    window.setTimeout(() => {
      firstField.focus();
    }, 0);
  }

  persistSubmission() {
    try {
      window.localStorage.setItem(this.storageKey, 'true');
      window.sessionStorage.removeItem(this.dismissedKey);
    } catch (error) {
      // Ignore storage failures and keep the gate functional.
    }
  }

  hasSubmitted() {
    try {
      return window.localStorage.getItem(this.storageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  persistDismissal() {
    try {
      window.sessionStorage.setItem(this.dismissedKey, 'true');
    } catch (error) {
      // Ignore storage failures and keep the gate functional.
    }
  }

  isDismissed() {
    try {
      return window.sessionStorage.getItem(this.dismissedKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  savePendingValues() {
    const values = {
      name: this.fields.name?.value || '',
      email: this.fields.email?.value || '',
      phone: this.fields.phone?.value || '',
      business: this.fields.business?.value || '',
      businessID: this.fields.businessID?.value || '',
      address: this.fields.address?.value || '',
    };

    try {
      window.sessionStorage.setItem(this.pendingKey, JSON.stringify(values));
    } catch (error) {
      // Ignore storage failures and keep the gate functional.
    }
  }

  restorePendingValues() {
    let values;

    try {
      values = JSON.parse(window.sessionStorage.getItem(this.pendingKey) || '{}');
    } catch (error) {
      values = {};
    }

    Object.entries(this.fields).forEach(([key, field]) => {
      if (!field || field.value || !values[key]) return;
      field.value = values[key];
    });
  }

  clearPendingValues() {
    try {
      window.sessionStorage.removeItem(this.pendingKey);
    } catch (error) {
      // Ignore storage failures and keep the gate functional.
    }
  }

  lockBody() {
    document.body.classList.add('overflow-hidden');
  }

  show() {
    document.documentElement.classList.remove('custom-wholesale-gate-submitted');
    document.body.classList.remove('custom-wholesale-gate-submitted');
    this.root.removeAttribute('hidden');
    this.lockBody();

    if (!this.content.dataset.customWholesaleGateState || this.content.dataset.customWholesaleGateState !== 'true') {
      this.focusFirstField();
    }
  }

  scheduleShow() {
    window.clearTimeout(this.showTimer);
    this.showTimer = window.setTimeout(() => {
      this.show();
    }, this.delayMs);
  }

  hide() {
    window.clearTimeout(this.showTimer);
    this.root.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
  }
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const button = target?.closest('[data-custom-wholesale-gate-dismiss]');
    const root = button?.closest('[data-custom-wholesale-gate]');
    if (!root) return;

    window.requestAnimationFrame(() => {
      const closeFailed = !root.hasAttribute('hidden') || document.body.classList.contains('overflow-hidden');

      if (closeFailed) {
        root.setAttribute('hidden', '');
        document.body.classList.remove('overflow-hidden');
      }
    });
  },
  true
);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-custom-wholesale-gate]').forEach((root) => {
    new CustomWholesaleGate(root).init();
  });
});
